module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n    防盗链设置\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group-list domain-list"
  }, [_c('div', {
    staticClass: "form-group margin-bottom-20"
  }, [_c('div', {
    staticClass: "form-group-item code-input-box select-box flex",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('p', {
    staticClass: "left-desc"
  }, [_vm._v("是否开启防盗链")]), _vm._v(" "), _c('div', {
    staticClass: "right-select-box flex1 flex",
    attrs: {
      "id": "upgradeSpace"
    }
  }, _vm._l((_vm.choose), function(item, index) {
    return _c('span', {
      staticClass: "another-option flex1per2",
      class: {
        'selected': _vm.chain == item.value
      },
      staticStyle: {
        "margin-right": "0.2rem"
      },
      on: {
        "click": function($event) {
          _vm.Choose(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }))]), _vm._v(" "), (_vm.chain === 'open') ? _c('div', {
    staticClass: "form-group-item"
  }, [_c('x-input', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "label-width": "8em",
      "title": "提示语"
    },
    model: {
      value: (_vm.fdl_txt),
      callback: function($$v) {
        _vm.fdl_txt = $$v
      },
      expression: "fdl_txt"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "margin-top": ".5rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("确认")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('div', {
    staticClass: "alert-warn margin-bottom-20 domain-list"
  }, [_c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("您网站上的音乐、视频、flash、压缩包文件、图片等，如果被其它网站或迅雷等软件盗用后，会对自己网站产生大量的无效流量并加重服务器负担。")]), _vm._v(" "), _c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("为了防止您的流量被盗用，系统默认开启了防盗链。")]), _vm._v(" "), _c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("默认设置受保护的文件后缀如下：.jpg， .gif， .png， .bmp， .mp3， .mp4， .wav， .wma， .rmvb， .avi， .wmv， .asf， .tar， .rm， .rpm， .mpg， .mpeg， .rar， .zip， .exe， .msi， .pdf。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fbda308","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/hostoperate/preventchain.vue
// module id = hOlZ
// module chunks = 1